module.exports = __webpack_public_path__ + "static/media/eversana_ending_bg_right.7addb6dc.png";